import React, { useEffect, useState } from "react";
import styles from '../styles/history.module.scss';
import CustomImage from "./CustomImage";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

interface Props {
  data: any
}

const HistoryAbt: React.FC<Props> = ({ data }) => {
  const [currentSlide, setCurrentSlide] = useState<any>(data[0])
  const [pastSlides, setPastSlides] = useState<any>([])
  const [futureSlides, setFutureSlides] = useState<any>([])
  useEffect(() => {
    const pastHistory = data.filter((element: any) => currentSlide.id > element.id)
    setPastSlides(pastHistory)
    const futureHistory = data.filter((element: any) => currentSlide.id < element.id)
    setFutureSlides(futureHistory)
  }, [currentSlide])
  return (
    <>
      <div id="history-about" className={styles.history}> <h2>Brief History</h2>
        <div className={styles.arowbt}>
          <div className={styles.arowbtalign} onClick={() => {
            if (pastSlides.length > 0) {
              setCurrentSlide(pastSlides[pastSlides.length - 1])
            }
          }}>
            <CustomImage src="/new-images/rb-right-a.svg" width={48} height={48} alt="RB-left"
              className={pastSlides.length > 0 ? styles.hoverClass : styles.hideClass} />
          </div>
          <div onClick={() => {
            if (futureSlides.length > 0) {
              setCurrentSlide(futureSlides[0])
            }
          }}>
            <CustomImage src="/new-images/rb-right-a.svg" width={48} height={48} alt="RB-right"
              className={futureSlides.length > 0 ? styles.hoverClass : styles.hideClass} />
          </div>
        </div>
        <div id="history-container" className={styles.hstoryContainer}>
          <Container>
            <Row>
              <Col xs={12} md={8} className={styles.containera}>
                <h3>{currentSlide.year}</h3>
                {pastSlides.length > 0 &&
                  <div className={styles.item}>
                    <h4>{pastSlides[pastSlides.length - 1].year}</h4>
                  </div>}
              </Col>
              <Col xs={12} md={8} className={styles.container}>
                <div className={`${styles.item} ${styles.histactive}`}>
                  <h3>{currentSlide.year}</h3>
                  <div className={styles.brifHist}>
                    <div>
                      <p>{currentSlide.title}</p>
                      <img src={currentSlide.imageUrl} width={370} height={235} alt="EdTech3" />
                    </div>
                  </div>
                </div>
                {futureSlides.length > 0 &&
                  futureSlides.map((slide: any) => {
                    return (
                      <div className={styles.item}>
                        <h3>{slide.year}</h3>
                      </div>
                    )
                  })
                }
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}

export default HistoryAbt;